export default "/images/5272d63b48c6ddd50f46af3016e2f37f.avif";